export const deDE = {
    price: 'Preis',
    apply: 'Sich bewerben',
    filterFor: 'Filtern nach',
    default: 'Standard',
    alphabetic: 'Alphabetisch',
    newest: 'Neuzugänge',
    popularity: 'Popularität',
    priceHighToLow: 'Preis: hoch bis niedrig',
    priceLowToHigh: 'Preis niedrig bis hoch',
    showMore: 'Zeig mehr',
    showPrev: 'Vorheriges anzeigen',
    noProductsFound: 'Keine Produkte gefunden',
    from: 'aus',
    outOfStock: 'Ausverkauft',
    addToCart: 'In den Warenkorb legen',
    addProductToCart: '{0} in den Warenkorb legen',
    showProduct: 'Zeig mehr',
};
export default deDE;
